import {
  delAddress,
  getPoints,
  getProductList,
  pointsExchange,
  getAddressList,
  modifyAddress,
  addAddressApi,
  checkProduct,
  getLotteryList,
  lotteryConfirm,
} from "@/api/api"
import { onMounted, ref, nextTick } from "vue"
import { ElIcon, ElCascader } from "element-plus"
import {
  ArrowRight,
  WarningFilled,
  ArrowLeftBold,
} from "@element-plus/icons-vue"
import { Tab, Tabs, Popup, showToast } from "vant"
import { storeParameterOncePerDay } from "@/utils/utils"
import "vant/lib/index.css"
import bus from "@/lib/bus"
import ProductList from "@/components/PointsMall/ProductList/ProductList.vue"
import NewProductList from "@/components/PointsMall/NewProductList/NewProductList.vue"
import { useRouter } from "vue-router"
import { areaList } from "@vant/area-data"
import { regionData, CodeToText } from "element-china-area-data"
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue"
import TurnTable from "@/components/TurnTable/TurnTable"
import Clipboard from "clipboard"
export default {
  components: {
    ArrowRight,
    WarningFilled,
    ArrowLeftBold,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    ProductList,
    NewProductList,
    ElIcon,
    ElCascader,
    ProgressBar,
    TurnTable,
  },
  props: ["gameId", "role_id"],
  setup(props, context) {
    // watch(
    //   [() => props.gameId, () => props.role_id],
    //   async ([newGameId, newRoleId], [oldGameId, oldRoleId]) => {
    //     let hasChanged = false

    //     if (newGameId !== oldGameId) {
    //       storeId.value = newGameId
    //       hasChanged = true
    //     }

    //     if (newRoleId !== oldRoleId) {
    //       roleId.value = newRoleId
    //       hasChanged = true
    //     }

    //     if (hasChanged) {
    //       await nextTick() // 等待 DOM 更新完成
    //       getDetailList()
    //     }
    //   }
    // )

    const storeId = ref(0)
    const roleId = ref(props.role_id)
    bus.$on("sendPointMall", (e) => {
      storeId.value = e.game_id
      roleId.value = e.role_id
      getDetailList()
    })
    const pointsNum = ref(0)
    // 获取当前用户积分
    const getPointsDetail = () => {
      getPoints().then((res) => {
        if (res.code == 200) {
          pointsNum.value = res.data.points
          localStorage.setItem("pointsNum", pointsNum.value)
          bus.$emit("points", pointsNum.value)
        } else {
          mobile.value = ""
          bus.$emit("loginOut")
        }
      })
    }
    const active = ref(0) //tab序号
    const hActive = ref(0) //tab id
    // 监听tab切换
    const changeTab = () => {
      frequency.value = 0
      realitySku.value = ""
      storeId.value = props.gameId
      if (activeName.value == 0) {
        nowProductType.value = "virtual"
        choiceProductType.value = 2
        bus.$emit("clearProductList")
        isSuccess.value = false
        getDetailList()
      } else if (activeName.value == 1) {
        choiceProductType.value = 3
        nowProductType.value = "reality"
        bus.$emit("clearProductList")
        isSuccess.value = false
        getDetailList()
      } else {
        nowProductType.value = "roll"
        getLotteryDetail()
      }
      changeProductType(nowProductType.value)
    }
    const tabList = ref([]) //tab列表
    const categoryId = ref(0) //对应游戏的gameId
    // 获取游戏的对应列表or实物列表
    const detailList = ref([]) //列表or实物列表
    const choiceItem = ref({}) //选择的兑换内容
    const getDetailList = () => {
      getProductList({
        game_id: storeId.value,
        type: nowProductType.value == "reality" ? 2 : 1,
        role_id: roleId.value || "",
      }).then((res) => {
        if (res.data.list.data.length > 0) {
          detailList.value = res.data.list.data
          if (!isSuccess.value && !choiceItem.value) {
            choiceItem.value = detailList.value[0]
          }
          if (choiceItem.value) {
            detailList.value.forEach((item) => {
              if (item.id == choiceItem.value.id) {
                choiceItem.value = item
              }
            })
          }
        } else {
          detailList.value = []
        }
      })
    }
    // 选择商品
    const choiceProduct = (e) => {
      if (!mobile.value) return
      choiceItem.value = e
      frequency.value = 0
      realitySku.value = ""
      getStock()
    }
    // h5选择商品
    const hChoiceProduct = (e) => {
      choiceItem.value = e
      frequency.value = 0
      realitySku.value = ""
      if (e.type == 4 && nowProductType.value == "reality") {
        choiceProductType.value = 4
      }
      if (e.type == 2 && nowProductType.value == "reality") {
        choiceProductType.value = 3
      }
      hShowExchangePopup()
    }
    const mobile = ref("") //个人信息
    const setWidth = ref(window.innerWidth > 390 ? 200 : 170)
    // 获取游戏对应的商品列表
    onMounted(() => {
      mobile.value = localStorage.getItem("mobile")
      storeId.value = props.gameId
      getDetailList()
      changeProductType(nowProductType.value)
      if (mobile.value) getPointsDetail()
    })
    const route = useRouter()
    const areadList = ref([]) //区服选择
    const choiceAread = ref("") //区服选择
    const choiceRole = ref("") //角色选择
    // 游戏角色确认
    bus.$on("roleInfo", (e) => {
      setTimeout(() => {
        if (!e.sysTem) {
          choiceAread.value = ""
          choiceRole.value = ""
          getStock()
          return
        }
        choiceAread.value = e
        choiceRole.value = e.nickname
        getStock()
      }, 0)
    })
    const lotteryType = ref(1) // 大转盘开启状态,1关闭2开启
    // 抽奖大转盘开启状态
    bus.$on("lotteryType", (e) => {
      lotteryType.value = Number(e)
    })
    const frequency = ref(0) //剩余可兑换次数
    // 获取角色对应的库存
    const getStock = () => {
      checkProduct({
        product_id: choiceItem.value.id,
        type: choiceProductType.value,
        game_id: storeId.value,
        server_id: choiceAread.value.dist_id,
        server_name: choiceAread.value.dist_name,
        role_id: choiceAread.value.role_id,
        role_name: choiceAread.value.nickname,
        os: choiceAread.value.os,
        address_id: defaultAddress.value.id,
      }).then((res) => {
        if (res.code == 200) {
          frequency.value =
            res.data.stock > choiceItem.value.stock
              ? choiceItem.value.stock
              : res.data.stock
          exchangeNum.value = res.data.stock > 0 ? "1" : 0
        } else if (res.code == 401) {
          bus.$emit("click") //未登录调取登录接口
        }
      })
    }
    const confirmationPopup = ref(false) // 确认弹窗
    const redemptionPopup = ref(false) // 兑换弹窗
    const isSuccess = ref(false) //是否为成功兑换
    const addressPopup = ref(false) //地址管理弹窗
    const addAddress = ref(false) //是否是添加新地址的页面
    const exchangePopup = ref(false) //移动端选择弹窗
    const hConfirmPopup = ref(false) //移动端兑换物品确认弹窗
    const hPhysicalPopup = ref(false) //移动端实物奖励领取弹窗
    const hAddressPopup = ref(false) //移动端地址选择列表
    const hAddressListPopup = ref(false) //移动端地址管理弹窗
    const hAddNewAddressPopup = ref(false) //移动端添加新地址/编辑地址
    const hAwardType = ref(1) //移动端选择商品类型，道具1，实物2
    const realitySku = ref("")
    // pc兑换弹窗点击
    const showConfirmPopup = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      if (nowProductType.value == "virtual") {
        if (!choiceRole.value) {
          return showToast("请选择区服角色")
        }
        if (frequency.value == 0) {
          return showToast("当前角色可兑换次数不足")
        }
        if (exchangeNum.value == 0) {
          return showToast("请选择兑换数量")
        }
        if (pointsNum.value < choiceItem.value.points) {
          return showToast("当前积分不足")
        }
        choiceProductType.value = 2
        confirmationPopup.value = true
      } else {
        if (!defaultAddress.value.address) {
          showToast("请添加收件信息")
          addressPopup.value = true
          return
        }
        if (choiceItem.value.stock == 0) {
          return showToast("库存不足")
        }
        if (choiceItem.value.attr_info.length > 0) {
          let list = []
          choiceItem.value.attr_info.forEach((item) => {
            item.val_info.forEach((subItem) => {
              if (subItem.choice) {
                list.push(subItem.id)
              }
            })
          })
          if (list.length < choiceItem.value.attr_info.length) {
            return showToast("请选择所有商品规格后重试")
          }
          realitySku.value = list.join(",")
        }
        choiceProductType.value = 3
        confirmationPopup.value = true
      }
    }
    // h5兑换弹窗点击
    const hShowConfirmPopup = () => {
      if (nowProductType.value == "virtual") {
        if (!choiceRole.value) {
          return showToast("请选择区服角色")
        }
        if (frequency.value == 0) {
          return showToast("当前角色可兑换次数不足")
        }
        if (exchangeNum.value == 0) {
          return showToast("请选择兑换数量")
        }
        if (pointsNum.value < choiceItem.value.points) {
          return showToast("当前积分不足")
        }
        choiceProductType.value = 2
        hConfirmPopup.value = false
        exchangePopup.value = false
        confirmBtn()
      } else {
        if (
          pointsNum.value < choiceItem.value.points ||
          pointsNum.value < choiceItem.value.points * exchangeNum.value
        ) {
          return
        }
        if (!defaultAddress.value.address && choiceItem.value.type != 4) {
          showToast("请添加收件信息")
          hAddNewAddressPopup.value = true
          return
        }
        if (choiceItem.value.stock == 0) {
          return showToast("库存不足")
        }

        if (choiceItem.value.attr_info.length > 0) {
          let list = []
          choiceItem.value.attr_info.forEach((item) => {
            item.val_info.forEach((subItem) => {
              if (subItem.choice) {
                list.push(subItem.id)
              }
            })
          })
          if (list.length < choiceItem.value.attr_info.length) {
            return showToast("请选择所有商品规格后重试")
          }
          realitySku.value = list.join(",")
        }
        hPhysicalPopup.value = false
        exchangePopup.value = false
        confirmBtn()
      }
    }
    // 兑换记录跳转
    const goExchangePage = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      if (serialNumber.value) {
        const clipboard = new Clipboard(document.body, {
          text: () => serialNumber.value,
        })

        clipboard.on("success", () => {
          showToast("复制成功")
          clipboard.destroy()
        })

        clipboard.on("error", (e) => {
          console.error("复制失败:", e)
          showToast("操作失败请重试！")
          clipboard.destroy()
        })
        return
      }
      route.push({
        path: `./exchangerecord`,
        query: {
          id: choiceItem.value.type != 1 ? 1 : 0,
        },
      })
    }
    // 积分记录跳转
    const goPointsDetail = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      route.push({
        path: `./integraldetail`,
      })
    }
    const nowProductType = ref("virtual") //当前商品的类型，虚拟或者实物
    // 切换物品兑换
    const changeProductType = (e) => {
      isSuccess.value = false
      if ((e == "reality" || e == "roll") && mobile.value) {
        getUserAddress()
      }
    }
    // 积分兑换物品
    const choiceProductType = ref(2) //2为虚拟道具，3为实物,4为实物道具里的虚拟物品
    const failTips = ref("") //兑换失败提示
    const serialNumber = ref("") //兑换提示文案
    const confirmBtn = () => {
      if (frequency.value == 0) return showToast("可兑换数量不足")
      if (exchangeNum.value == 0) return showToast("请输入兑换数量")
      serialNumber.value = ""
      pointsExchange({
        product_id: choiceItem.value.id,
        type: choiceProductType.value,
        game_id: nowProductType.value == "virtual" ? storeId.value : 0,
        server_id: choiceAread.value.dist_id,
        server_name: choiceAread.value.dist_name,
        role_id: choiceAread.value.role_id,
        role_name: choiceAread.value.nickname,
        os: choiceAread.value.os,
        address_id: defaultAddress.value.id,
        num: exchangeNum.value,
        specific: realitySku.value,
      }).then((res) => {
        confirmationPopup.value = false
        hConfirmPopup.value = false
        exchangePopup.value = false
        hPhysicalPopup.value = false
        if (res.code == 200) {
          isSuccess.value = true
          serialNumber.value = res.data.serialNumber
          getPointsDetail()
          getDetailList()
        } else {
          isSuccess.value = false
          failTips.value = res.message
        }
        if (nowProductType.value == "virtual") {
          getStock()
        }
        redemptionPopup.value = true
      })
    }
    const addressList = ref([]) //用户地址列表
    const defaultAddress = ref({}) //默认地址
    //获取用户地址
    const getUserAddress = () => {
      getAddressList().then((res) => {
        addressList.value = res.data.list.data
        if (addressList.value.length > 0 && !defaultAddress.value.address) {
          addressList.value.forEach((item) => {
            if (item.is_default == 1) {
              defaultAddress.value = item
            }
          })
          if (!defaultAddress.value.address) {
            defaultAddress.value = addressList.value[0]
          }
        }
      })
    }
    // 关闭地址编辑弹窗
    const closeAddressPopup = () => {
      addressPopup.value = false
      addAddress.value = false
    }
    // pc显示地址弹窗
    const showAddrssPopup = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      if (!defaultAddress.value.address) {
        addAddress.value = true
        addressType.value = 2
      } else {
        addAddress.value = false
      }
      addressPopup.value = true
    }
    // 移动端显示地址弹窗
    const hShowAddrssPopup = () => {
      if (!defaultAddress.value.address) {
        hAddNewAddressPopup.value = true
        addressType.value = 2
      } else {
        hAddressListPopup.value = true
      }
    }
    const detailedAddress = ref("") //地址
    const tel = ref("") //电话
    const username = ref("") //收件人
    const editorId = ref("") //修改地址需要的id
    const addressType = ref(1) //1为编辑，2为添加
    const defaultAddressType = ref(false) //默认地址设置

    // h5编辑or添加地址
    const hEditorAddress = (e) => {
      if (e) {
        defaultAddressType.value = e.is_default == 1 ? true : false
        username.value = e.consignee
        tel.value = e.phone
        detailedAddress.value = e.address
        editorId.value = e.id
        addressType.value = 1
        nowIndex.value = e.area_id.split(",")[2] || e.area_id.split(",")[1]
        selectedOptions.value = e.area_id.split(",")
        provincesList.value = [
          {
            text: e.province,
          },
          {
            text: e.city,
          },
          {
            text: e.area,
          },
        ]
      } else {
        defaultAddressType.value = false
        username.value = ""
        tel.value = ""
        detailedAddress.value = ""
        addressType.value = 2
        nowIndex.value = ""
        selectedOptions.value = []
        provincesList.value = []
      }
      hAddNewAddressPopup.value = true
    }
    // 手机号正则
    const isPhoneNum = (phoneNum) => {
      const reg = /^1[3456789]\d{9}$/
      return reg.test(phoneNum)
    }
    // 保存or修改地址
    const saveAddress = () => {
      if (
        !detailedAddress.value ||
        !tel.value ||
        !username.value ||
        !provincesList.value
      )
        return showToast("请正确填写收件信息")
      if (!isPhoneNum(tel.value)) return showToast("请填写正确的手机号")
      if (addressList.value.length == 0) {
        defaultAddressType.value = true
        addressType.value = 2
      }
      if (addressType.value == 1) {
        modifyAddress({
          id: editorId.value,
          consignee: username.value,
          address: detailedAddress.value,
          phone: tel.value,
          province: provincesList.value[0].text,
          city: provincesList.value[1].text,
          area: provincesList.value[2].text ? provincesList.value[2].text : "",
          area_id: selectedOptions.value.join(","),
          is_default: defaultAddressType.value ? 1 : 2,
        }).then((res) => {
          if (res.code == 200) {
            showToast("修改地址成功")
            getUserAddress()
            addAddress.value = false
            hAddNewAddressPopup.value = false
          } else {
            showToast(res.message)
          }
        })
      } else {
        addAddressApi({
          consignee: username.value,
          address: detailedAddress.value,
          phone: tel.value,
          province: provincesList.value[0].text,
          city: provincesList.value[1].text,
          area: provincesList.value[2].text ? provincesList.value[2].text : "",
          area_id: selectedOptions.value.join(","),
          is_default: defaultAddressType.value ? 1 : 2,
        }).then((res) => {
          if (res.code == 200) {
            showToast("添加地址成功")
            if (realityPrizeId.value && addressList.value.length == 0) {
              confirmAddress()
            }
            getUserAddress()
            addAddress.value = false
            hAddNewAddressPopup.value = false
          } else {
            showToast(res.message)
          }
        })
      }
    }
    // 删除地址
    const deleteAddress = () => {
      delAddress({
        id: editorId.value,
      }).then((res) => {
        if (res.code == 200) {
          showToast("删除地址成功")
          defaultAddress.value = ""
          getUserAddress()
          addAddress.value = false
          hAddNewAddressPopup.value = false
        } else {
          showToast(res.message)
        }
      })
    }
    // 返回列表
    const addressBack = () => {
      if (defaultAddress.value.address) {
        addAddress.value = false
        return
      }
      addressPopup.value = false
    }
    // 选择收件地址
    const selectAddress = (e) => {
      defaultAddress.value = e
      addressPopup.value = false
      hAddressListPopup.value = false
      // 如果为大转盘，做参数回传
      if (realityPrizeId.value) {
        confirmAddress()
      }
    }
    // 登录
    const loginBtn = () => {
      return bus.$emit("click") //未登录调取登录接口
    }

    // 登录成功
    bus.$on("login", () => {
      mobile.value = localStorage.getItem("mobile")
      getPointsDetail()
      if (
        nowProductType.value == "virtual" ||
        nowProductType.value == "reality"
      ) {
        getDetailList()
      }
      if (nowProductType.value == "reality") {
        getUserAddress()
      }
      if (nowProductType.value == "roll") {
        getLotteryDetail()
      }
    })
    // 注销监听
    bus.$on("clear", () => {
      mobile.value = ""
      pointsNum.value = 0
      choiceAread.value = ""
      choiceRole.value = ""
      getLotteryDetail()
    })
    const h5BotBody = ref(null)
    // h5确认兑换按钮(虚拟道具跟实物共用，谨慎调整)
    const hShowExchangePopup = () => {
      if (!mobile.value) {
        return loginBtn()
      }
      getStock()
      if (nowProductType.value == "virtual") {
        hConfirmPopup.value = true
      } else {
        exchangePopup.value = true
        setTimeout(() => {
          if (h5BotBody.value) h5BotBody.value.scrollTop = 0
        }, 0)
      }
    }
    const immediateExchange = () => {
      // exchangePopup.value = false
      hPhysicalPopup.value = true
    }
    const isMobile = () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    }

    const addressListPopup = ref(false) // h5地址弹窗
    const provincesList = ref([]) //省市区选择
    const nowIndex = ref("") //h5选择的地区码
    const selectedOptions = ref([]) //pc端地址选择序号
    // h5选择省市区
    const confirmSf = (e) => {
      if (e.selectedOptions[2].text) {
        nowIndex.value = e.selectedOptions[2].value
        selectedOptions.value = [
          e.selectedOptions[0].value,
          e.selectedOptions[1].value,
          e.selectedOptions[2].value,
        ]
      } else {
        nowIndex.value = e.selectedOptions[1].value
        selectedOptions.value = [
          e.selectedOptions[0].value,
          e.selectedOptions[1].value,
        ]
      }
      provincesList.value = e.selectedOptions
      addressListPopup.value = false
    }

    const exchangeNum = ref(0) //兑换数量
    const isClickChoice = ref(false) //判断是否点击的实物商品的sku选项
    //实物兑换sku选择
    const choiceRealityType = (e, i) => {
      if (i.stock == 0) return showToast("当前选项库存不足")
      isClickChoice.value = true
      choiceItem.value.attr_info.forEach((item) => {
        if (item.id == e.id) {
          item.val_info.forEach((subItem) => {
            if (subItem.id == i.id) {
              subItem.choice = true
              frequency.value = subItem.stock
            } else subItem.choice = false
          })
        }
      })
    }
    //积分不足提示文案调整按钮
    const changePageType = () => {
      hPhysicalPopup.value = false
      context.emit("changeCashCoupon")
    }
    // 实物兑换步进器最大值提示
    const overlimit = (e) => {
      if (e == "minus") showToast("兑换数量不能小于1")
      else showToast("已达最大兑换次数")
    }
    const closeHPhysicalPopup = () => {
      isClickChoice.value = false
      choiceItem.value.attr_info.forEach((item) => {
        item.val_info.forEach((subItem) => {
          subItem.choice = false
          frequency.value = 0
        })
      })
    }
    // 关闭兑换成功弹窗后触发
    const closeRedemptionPopup = () => {
      storeParameterOncePerDay("pwaToday")
    }
    const activeName = ref(0) //积分兑换商品类型
    const backgroundImage = new URL(
      "@/assets/image/snail/new-year-snail-bgc.jpg",
      import.meta.url
    ).href
    const backgroundImageSec = new URL(
      "@/assets/image/snail/new-year-snail-bgc2.png",
      import.meta.url
    ).href
    const firstTurnTable = ref(null)
    const secTurnTable = ref(null)
    // 初始化大转盘
    const initRoll = () => {
      firstTurnTable.value.initRoll()
      secTurnTable.value.initRoll()
    }
    const lotteryList = ref([]) //大转盘内容
    // 获取大转盘内容
    const getLotteryDetail = () => {
      getLotteryList({
        game_id: storeId.value,
      }).then((res) => {
        if (res.code == 200) {
          lotteryList.value = res.data.list.data
        }
      })
    }
    // 抽奖后刷新大转盘
    const lotteryRefresh = () => {
      getLotteryDetail()
      getPointsDetail()
    }
    const realityPrizeId = ref("") //大转盘奖盘id
    // 大转盘获得实物奖励后执行地址弹窗
    const realityPrize = (id) => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      realityPrizeId.value = id
      hShowAddrssPopup()
    }
    // 抽奖地址确认
    const confirmAddress = () => {
      lotteryConfirm({
        id: realityPrizeId.value,
        address_id: defaultAddress.value.id,
      }).then((res) => {
        if (res.code == 200) {
          showToast("地址填写成功")
        }
      })
    }
    // 大转盘获奖为红包
    const redPagePrize = (id) => {
      serialNumber.value = id
      isSuccess.value = true
      choiceItem.value.type = 4
      redemptionPopup.value = true
    }
    const changeTabToRoll = () => {
      nextTick(() => {
        console.log("test")
        activeName.value = 2
        nowProductType.value = "roll"
        getLotteryDetail()
        changeProductType(nowProductType.value)
      })
    }
    return {
      changeTabToRoll,
      lotteryRefresh,
      redPagePrize,
      confirmAddress,
      realityPrizeId,
      realityPrize,
      lotteryList,
      getLotteryDetail,
      firstTurnTable,
      secTurnTable,
      initRoll,
      backgroundImageSec,
      backgroundImage,
      activeName,
      closeRedemptionPopup,
      closeHPhysicalPopup,
      isClickChoice,
      h5BotBody,
      serialNumber,
      overlimit,
      changePageType,
      immediateExchange,
      roleId,
      setWidth,
      deleteAddress,
      defaultAddressType,
      realitySku,
      choiceRealityType,
      exchangeNum,
      selectedOptions,
      regionData,
      CodeToText,
      nowIndex,
      provincesList,
      confirmSf,
      addressListPopup,
      areaList,
      isPhoneNum,
      failTips,
      isMobile,
      hChoiceProduct,
      hEditorAddress,
      hShowAddrssPopup,
      hShowConfirmPopup,
      hShowExchangePopup,
      loginBtn,
      getStock,
      mobile,
      frequency,
      selectAddress,
      addressBack,
      showAddrssPopup,
      addressType,
      closeAddressPopup,
      saveAddress,
      detailedAddress,
      tel,
      username,
      defaultAddress,
      addressList,
      getUserAddress,
      nowProductType,
      changeProductType,
      choiceProductType,
      confirmBtn,
      showConfirmPopup,
      choiceProduct,
      choiceItem,
      choiceAread,
      choiceRole,
      areadList,
      changeTab,
      getDetailList,
      categoryId,
      detailList,
      pointsNum,
      getPointsDetail,
      tabList,
      goPointsDetail,
      goExchangePage,
      hActive,
      hAwardType,
      hAddNewAddressPopup,
      hAddressListPopup,
      hAddressPopup,
      hPhysicalPopup,
      active,
      confirmationPopup,
      redemptionPopup,
      isSuccess,
      addressPopup,
      addAddress,
      exchangePopup,
      hConfirmPopup,
      storeId,
      lotteryType,
    }
  },
}
